import PropTypes from 'prop-types'
import React, { Component } from 'react'
import keyname from 'keyname'
import { ASSET_BASE_URL } from 'config'
import withBodyScrollDisabled from './withBodyScrollDisabled'
import './Sheet.css'

class Sheet extends Component {
  render () {
    const bodyStyle = this.props.isPadded ? {} : { padding: '0px' }
    return (
      <div className='SheetOverlay' onClick={this.props.onClose} onKeyDown={this.onKeydown.bind(this)}>
        <div className='Sheet'>
          <div className='SheetClose'>
            <img src={`${ASSET_BASE_URL}/ui/sheet/close.svg`} alt='Close' />
          </div>
          <div className='SheetWrapper'>
            <div className='SheetBody' data-wide={this.props.wide} style={bodyStyle} onClick={e => e.stopPropagation()}>
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    )
  }

  onKeydown (e) {
    if (keyname(e.which) === 'esc') {
      if (this.props.onClose) {
        this.props.onClose()
      }
    }
  }
}

Sheet.displayName = 'Sheet'

Sheet.defaultProps = {
  isPadded: true
}

Sheet.propTypes = {
  wide: PropTypes.bool,
  onClose: PropTypes.func,
  isPadded: PropTypes.bool,
  children: PropTypes.node
}

export default withBodyScrollDisabled(Sheet)



// WEBPACK FOOTER //
// ./ui/Sheet.js